
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import InvoicesList from './components/InvoicesList';
import InvoiceForm from './components/InvoiceForm';
import PaymentsList from './components/PaymentsList';
import PaymentForm from './components/PaymentForm';
import DueDatesBoard from './components/DueDatesBoard';
import CollectionManagement from './components/CollectionManagement';
import CreditReporting from './components/CreditReporting';

export default function InvoicesPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('invoices');
  const [showInvoiceForm, setShowInvoiceForm] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [selectedInvoiceForPayment, setSelectedInvoiceForPayment] = useState(null);
  const navigate = useNavigate();

  const handleAddInvoice = () => {
    setEditingInvoice(null);
    setShowInvoiceForm(true);
  };

  const handleEditInvoice = (invoice: any) => {
    setEditingInvoice(invoice);
    setShowInvoiceForm(true);
  };

  const handleCloseInvoiceForm = () => {
    setShowInvoiceForm(false);
    setEditingInvoice(null);
  };

  const handlePayInvoice = (invoice: any) => {
    setSelectedInvoiceForPayment(invoice);
    setShowPaymentForm(true);
  };

  const handleClosePaymentForm = () => {
    setShowPaymentForm(false);
    setSelectedInvoiceForPayment(null);
  };

  const handleSavePayment = (paymentData: any) => {
    console.log('Règlement enregistré:', paymentData);
    // Ici, vous ajouteriez la logique pour:
    // 1. Sauvegarder le règlement
    // 2. Mettre à jour le statut de la facture
    // 3. Déduire le montant de la caisse/banque
    alert('Règlement enregistré avec succès! Le statut de la facture a été mis à jour.');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 sm:mb-8 flex items-center space-x-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                title="Retour au tableau de bord"
              >
                <i className="ri-arrow-left-line text-xl text-gray-600"></i>
              </button>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Factures Clients</h1>
                <p className="text-sm sm:text-base text-gray-600">Gestion des factures et paiements clients</p>
              </div>
            </div>

            {/* Onglets de navigation */}
            {!showInvoiceForm && !showPaymentForm && (
              <div className="mb-4 sm:mb-6">
                <div className="border-b border-gray-200 overflow-x-auto">
                  <nav className="-mb-px flex space-x-4 sm:space-x-8 min-w-max">
                    <button
                      onClick={() => setActiveTab('invoices')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'invoices'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-file-list-3-line"></i>
                      <span>Factures</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('due-dates')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'due-dates'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-calendar-check-line"></i>
                      <span>Échéances</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('payments')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'payments'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-money-dollar-circle-line"></i>
                      <span>Règlements</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('collection')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'collection'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-alarm-warning-line"></i>
                      <span>Recouvrement</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('credit-reporting')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-2 ${
                        activeTab === 'credit-reporting'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-bar-chart-box-line"></i>
                      <span>Reporting Crédit</span>
                    </button>
                  </nav>
                </div>
              </div>
            )}

            {showPaymentForm ? (
              <PaymentForm 
                invoice={selectedInvoiceForPayment}
                onClose={handleClosePaymentForm}
                onSave={handleSavePayment}
              />
            ) : showInvoiceForm ? (
              <InvoiceForm 
                invoice={editingInvoice}
                onClose={handleCloseInvoiceForm}
              />
            ) : (
              <>
                {activeTab === 'invoices' && (
                  <InvoicesList 
                    onEdit={handleEditInvoice}
                    onAdd={handleAddInvoice}
                    onPay={handlePayInvoice}
                  />
                )}
                {activeTab === 'due-dates' && (
                  <DueDatesBoard 
                    onPay={handlePayInvoice}
                  />
                )}
                {activeTab === 'payments' && (
                  <PaymentsList />
                )}
                {activeTab === 'collection' && (
                  <CollectionManagement 
                    onPayInvoice={handlePayInvoice}
                  />
                )}
                {activeTab === 'credit-reporting' && (
                  <CreditReporting />
                )}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
